import React from 'react'
import { Field, useFormikContext } from 'formik'

const Input = (props) => {
  const { name, className, ...rest } = props
  const { errors, touched } = useFormikContext()
  const hasError = errors[name] && touched[name]

  return (
    <Field
      id={name}
      name={name}
      className={`${className || ''} ${hasError ? 'input-error' : ''}`.trim()}
      {...rest}
    />
  )
}

export default Input
